<template>
    <BaseGuidelineCards
        v-if="items && items.length"
        :cards="booksCards"
        :is-loading="pending"
    />
    <p v-else>
        There are no programmes related to this page right now.
        <nuxt-link to="/undergraduates">See all programmes</nuxt-link>
    </p>
</template>

<script setup>
import relatedBooksQuery from '~/graphql/queries/books/related.graphql';

const props = defineProps({
    relatedToEntryId: {
        type: [Number, String],
        required: false,
        default: null
    },
    relatedToTagId: {
        type: [Number, String],
        required: false,
        default: null
    }
});

const { variables } = useCraftVariables();

variables.limit = 3;

if (props.relatedToEntryId) {
    variables.relatedToEntries = [{ id: props.relatedToEntryId }];
}
if (props.relatedToTagId) {
    variables.relatedToTags = [{ id: props.relatedToTagId }];
}

const { data } = await useLazyAsyncQuery({
    query: relatedBooksQuery,
    variables,
});

const items = computed(() => {
    return data.value?.books;
});

const booksCards = computed(() => {
    return items.value.map((book) => {
        return {
            title: book.title,
            url: '/' + book.uri
        };
    });
});
</script>
